// src/utils/loadGoogleMaps.ts

let isLoading = false;
let isLoaded = false;

export const loadGoogleMaps = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    // If already loaded, resolve immediately
    if (isLoaded && window.google && window.google.maps) {
      resolve();
      return;
    }

    // If currently loading, wait for it
    if (isLoading) {
      const checkInterval = setInterval(() => {
        if (isLoaded && window.google && window.google.maps) {
          clearInterval(checkInterval);
          resolve();
        }
      }, 100);
      return;
    }

    isLoading = true;

    // Get API key from environment
    const apiKey = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
    
    if (!apiKey || apiKey === 'YOUR_API_KEY') {
      reject(new Error('Google Maps API key not configured'));
      return;
    }

    // Create callback
    (window as any).initGoogleMaps = () => {
      console.log('✅ Google Maps API loaded successfully');
      isLoaded = true;
      isLoading = false;
      (window as any).googleMapsReady = true;
      window.dispatchEvent(new Event('googleMapsReady'));
      resolve();
    };

    // Create script element
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry,geocoding&callback=initGoogleMaps&loading=async`;
    script.async = true;
    script.defer = true;
    
    script.onerror = () => {
      isLoading = false;
      reject(new Error('Failed to load Google Maps'));
    };

    // Add to document
    document.head.appendChild(script);
  });
};